module.exports = __webpack_public_path__ + "img/avatar6.b2cdac6d.png";